import Button from '@/presentation/components/elements/Button';
import SelectInventoryForm, {
  SelectInventoryFormFields,
} from '@/presentation/components/forms/CreatePositionForms/SelectInventoryForm';
import { useForm, useWatch } from 'react-hook-form';
import { Address } from 'viem';
import { Dispatch } from 'react';
import { Asset, TokenId, getTotalTokenIds } from 'nftx.js';
import { IncreaseLiquidityDetails } from '../types';
import { QueryStatus } from '@tanstack/react-query';

export interface SelectInventoryProps {
  symbol: string;
  collection: Address;
  collectionName: string;
  vaultId?: string;
  icon?: string;
  dispatch: Dispatch<Partial<IncreaseLiquidityDetails>>;
  onSubmit: (...args: any) => void;
  userAssets?: Asset[];
  items: IncreaseLiquidityDetails['items'];
  withinModal?: boolean;
  is1155: boolean;
  status: QueryStatus;
}

export const SelectInventory = ({
  symbol,
  vaultId,
  icon,
  collection,
  dispatch,
  onSubmit,
  userAssets,
  collectionName,
  items,
  withinModal,
  is1155,
  status,
}: SelectInventoryProps) => {
  const {
    control,
    register,
    formState: { errors },
    setValue,
    handleSubmit,
  } = useForm<SelectInventoryFormFields>({
    defaultValues: {
      items,
    },
  });

  const values = useWatch({ control });
  const hasItems =
    values.items?.some((item) => item.quantity == null || item.quantity > 0n) ??
    false;

  const onPoolFormSubmit = handleSubmit(async (values) => {
    const tokenAmount = getTotalTokenIds(
      values.items.map(
        ({ tokenId, quantity }) =>
          [tokenId, Number(quantity ?? 1n)] as [TokenId, number]
      )
    ).toString();
    dispatch({ ...values, tokenAmount });
    onSubmit();
  });

  return (
    <form onSubmit={onPoolFormSubmit}>
      <SelectInventoryForm
        {...{
          status,
          setValue,
          control,
          register,
          errors,
          symbol,
          vaultId,
          icon,
          collection,
          collectionName,
          userAssets,
          showCounter: true,
          withinModal,
          is1155,
        }}
      />
      <Button
        size="xl"
        type="submit"
        className="w-full mt-6"
        disabled={!hasItems}
      >
        {'Next'}
      </Button>
    </form>
  );
};

export default SelectInventory;
